$(document).ready(function(){
  $(document).on('click', '[data-behaviour~=anchor-scroll]', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $target = $this.data('target');
    console.log($target);
    if($target){
      $('html, body').stop().animate({
        scrollTop: $('#' + $target ).offset().top - 160
      }, 400);
    }
    return false;
  });
  $('.scrollTop a').scrollTop();
});
